import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as typeMessages from '../../store/typeMessages'

import { Header } from '../../utils/Utils'
import { Row, Col, Collapse } from 'antd'

import Gauge from '../../charts/Gauge'
import LedStatus from '../../charts/LedStatus'
import Indicator from '../../charts/Indicator'
import ProcessDiagram from './ProcessDiagram'


const Panel = Collapse.Panel

class Mosaic extends Component {
  constructor (props) {
    super(props)  
    this.state = { showline: false }
  }

  showline (activeKeys) {
    if (activeKeys.includes('1')) return this.setState({ showline: false })
    this.setState({ showline: true })
  }

  render () {
    let { pressure, slunt1, slunt2, temperature, connect } = this.props

    let header = <Header
      title='Umbita'
      indicators={[
        [pressure, 'PSI', '#fa8c16']
      ]}
      showline={this.state.showline}
      connect={connect} />

    return (
      <Collapse
        defaultActiveKey={['1']}
        style={{ overflow: 'hiden' }}
        onChange={this.showline.bind(this)}
        bordered={false} >
        <Panel
          header={header}
          key='1'
          disabled={this.state.disable} align='center'>
          <Row type='flex' align='middle' justify='center' style={{
            filter: `grayscale(${connect ? 0 : 1})`
          }}>
            <Col xs={24} sm={5} md={5} lg={24} xl={5} xxl={5}>
              <div style={{
                display: 'flex',
                flexFlow: 'row wrap',
                justifyContent: 'space-around',
                alignContent: 'center'
              }}>
                <Gauge
                  unit='PSI'
                  width={90}
                  stops={[
                    [0.7, '#a0d911'],
                    [0.9, '#faad14'],
                    [0.95, '#f5222d']
                  ]}
                  min={0}
                  max={200}
                  title='PRESSURE'
                  data={pressure}
                />
                <div>
                  <LedStatus
                    width={45}
                    isOn={slunt1 ? 0 : 1}
                    onColor='#a0d911'
                    offColor='#002b4c'
                    tittle='Slunt 1'
                  />
                  <LedStatus
                    width={45}
                    isOn={slunt2 ? 0 : 1}
                    onColor='#a0d911'
                    offColor='#002b4c'
                    tittle='Slunt 2'
                  />
                </div>
                <Indicator
                width={130}
                value={temperature}
                type='icon-thermometer'
                title='temperature'
                colors={['#002b4c', '#d4b106']}
                threshold={[0, Infinity]}
                unit='&deg;F' />
              </div>
            </Col>
            <Col xs={24} sm={19} md={19} lg={19} xl={19} xxl={19}>
              <ProcessDiagram />
            </Col>
          </Row>
        </Panel>
      </Collapse>
    )
  }
}

function mapStateToProps (state) {
  let { umbita } = state.locations
  return {
    slunt1: umbita.indicators.slunt1.lastValue,
    slunt2: umbita.indicators.slunt2.lastValue,
    pressure: umbita.indicators.pressure2.lastValue,
    temperature: umbita.indicators.temperature.lastValue,
    connect: umbita.connect
    // temperature: paez.indicators.temperature.lastValue
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators(typeMessages, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Mosaic)



// WEBPACK FOOTER //
// ./src/boards/umbita/Mosaic.js